import { ExpandMore } from '@mui/icons-material'
import { Components, Theme } from '@mui/material'

export const MuiAccordion: Components<Omit<Theme, 'components'>>['MuiAccordion'] = {
  defaultProps: {
    disableGutters: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.futureTheme.bg.invisible,
      '&.Mui-disabled': {
        backgroundColor: theme.palette.futureTheme.bg.invisible,
      },
      color: theme.palette.futureTheme.text.default,
      // MUI uses this to apply a default white highlight (via --Paper-overlay)
      backgroundImage: 'none',
      boxShadow: 'none',
      border: 'none',
      '&, &:first-of-type, &:last-of-type': {
        borderRadius: 0,
      },
      // Remove border between Accordions when multiple are used together
      '&::before': {
        display: 'none',
      },
    }),
  },
}

export const MuiAccordionSummary: Components<Omit<Theme, 'components'>>['MuiAccordionSummary'] = {
  defaultProps: {
    // TODO - proper icon
    expandIcon: <ExpandMore />,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '&, &.Mui-expanded': {
        minHeight: 'unset',
      },
      padding: theme.spacing(0, 4, 0, 3),
      '&:hover': {
        backgroundColor: theme.palette.futureTheme.bg.interactive.hover,
      },
    }),
    content: ({ theme }) => ({
      '&, &.Mui-expanded': {
        margin: theme.spacing(2, 0),
      },
      ...theme.typography['futureTheme.body-semiBold'],
    }),
    expandIconWrapper: ({ theme }) => ({
      padding: theme.spacing(1),

      color: theme.palette.futureTheme.fg.muted,

      // TODO - updated icon
      '& .MuiSvgIcon-root': {
        fontSize: '20px',
      },
    }),
  },
}

export const MuiAccordionDetails: Components<Omit<Theme, 'components'>>['MuiAccordionDetails'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(2, 4, 4, 12),
      backgroundColor: theme.palette.futureTheme.bg.surface.default,
    }),
  },
}

export const MuiAccordionActions: Components<Omit<Theme, 'components'>>['MuiAccordionActions'] = {}
